export const Rights = [
    "WEB_MODULE_PILOT_COURSE_ATTENDEE_READ",
    "WEB_MODULE_PILOT_COURSE_ATTENDEE_WRITE"
]
